export function suggestMonitor({use,display,arm},available) {
  if (!['home','away'].includes(use)||!['colour','compact','neutral'].includes(display)||!['unknown','xs','standard','large','xl','other'].includes(arm)) return {state:'incomplete'};
  if (arm==='other') return {state:'fit-help'};
  const model=display==='colour'?'senior-elite':display==='compact'||use==='away'?'travel-lite':'home-pro';
  if (!available.includes(model)) return {state:'unavailable'};
  return {state:'suggestion',model,measure:arm==='unknown'};
}
export function initializeFinders(document) {
  for (const root of document.querySelectorAll('[data-ouson-finder]')) {
    if (root.dataset.bound) continue;
    const form=root.querySelector('form'),status=root.querySelector('[data-finder-status]'),note=root.querySelector('[data-finder-note]'),help=root.querySelector('[data-finder-help]'),cards=[...root.querySelectorAll('[data-finder-model]')];
    if (!form||!status||!note||!help) continue;
    root.dataset.bound='true';
    const clear=()=>{for(const card of cards)card.hidden=true;help.hidden=true;note.textContent='';status.textContent=root.dataset.initial;};
    const show=()=>{
      clear();
      const result=suggestMonitor({use:form.elements.use.value,display:form.elements.display.value,arm:form.elements.arm.value},cards.filter(c=>c.dataset.available==='true').map(c=>c.dataset.finderModel));
      if(result.state==='incomplete')return;
      if(result.state==='fit-help'||result.state==='unavailable'){status.textContent=result.state==='fit-help'?root.dataset.other:root.dataset.unavailable;help.hidden=false;return;}
      const card=cards.find(c=>c.dataset.finderModel===result.model);card.hidden=false;
      status.textContent=root.dataset.suggestion.replace('__PRODUCT__',card.dataset.name);
      note.textContent=result.measure?root.dataset.unknown:root.dataset.fit;
    };
    form.addEventListener('submit',event=>{event.preventDefault();show();});
    form.addEventListener('change',clear);
    form.addEventListener('reset',clear);
    clear();root.hidden=false;
  }
}
if(typeof document!=='undefined')initializeFinders(document);
